var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocatinGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51304 20.6C8.51304 20.6 16.0261 13.9218 16.0261 8.91307C16.0261 4.76373 12.6624 1.40002 8.51304 1.40002C4.3637 1.40002 1 4.76373 1 8.91307C1 13.9218 8.51304 20.6 8.51304 20.6Z",
    stroke: "#9D9D9D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9134 8.60018C10.9134 9.92566 9.83883 11.0002 8.51335 11.0002C7.18787 11.0002 6.11335 9.92566 6.11335 8.60018C6.11335 7.27469 7.18787 6.20018 8.51335 6.20018C9.83883 6.20018 10.9134 7.27469 10.9134 8.60018Z",
    stroke: "#9D9D9D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocatinGray);
export default __webpack_public_path__ + "static/media/locatin-gray.14eecd3965c46820e66ebf3bafabd82b.svg";
export { ForwardRef as ReactComponent };